import React, { useState } from 'react';
import Icon from '../../components/Icon';

// Small pieces shared by the Blog, Ad copy and Script generators

export const Field = ({ label, children, hint }) => (
    <label style={{ display: 'flex', flexDirection: 'column', gap: 6, minWidth: 0 }}>
        <span className="ls-label">{label}</span>
        {children}
        {hint && <span style={{ fontSize: 12, color: 'var(--muted)' }}>{hint}</span>}
    </label>
);

export const CopyButton = ({ text, label = 'Copy' }) => {
    const [copied, setCopied] = useState(false);
    const copy = async () => {
        try {
            await navigator.clipboard.writeText(text);
            setCopied(true);
            setTimeout(() => setCopied(false), 1500);
        } catch (e) {
            // Clipboard unavailable; the text can still be selected by hand
        }
    };
    return (
        <button type="button" className="ls-btn ls-btn-pill" onClick={copy}>
            <Icon name={copied ? 'check' : 'content_copy'} size={14} />{copied ? 'Copied' : label}
        </button>
    );
};

// `secondary` once there's a result: then the step's "Next" is the main action
export const GenerateButton = ({ isLoading, onClick, label, loadingLabel, secondary = false }) => (
    <button type="button" className={`ls-btn ${secondary ? 'ls-btn-secondary' : 'ls-btn-primary'}`} onClick={onClick} disabled={isLoading} style={{ alignSelf: 'flex-start' }}>
        {isLoading
            ? <span className="ls-spinner" style={secondary ? undefined : { borderTopColor: 'var(--accent-ink)', borderColor: 'rgba(5, 48, 44, .25)' }} />
            : <Icon name="auto_awesome" size={18} />}
        {isLoading ? loadingLabel : label}
    </button>
);

export const ErrorBanner = ({ message }) => (message ? (
    <div className="ls-error" role="alert"><Icon name="error" />{message}</div>
) : null);

export const formGrid = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: 14,
};
